import type {
    PatchCodeRegistrationType,
    PostActivateEmailType,
    PostEmailDataType,
    PutConsentDataType,
} from '@/services/registration/types';

import { REGISTRATION, REGISTRATION_PASSWORD_RESET } from './constants';

export const postEmailData: PostEmailDataType = async (
    email,
    phone,
    captcha,
) => {
    const data = {
        email,
        phone,
        captcha,
    };

    return await fetch(REGISTRATION, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
        },
        body: JSON.stringify(data),
    }).then(res => {
        if (!res.ok) {
            throw res.json();
        }

        return res.json();
    });
};

export const patchCodeRegistrationData: PatchCodeRegistrationType = async (
    id,
    discountCode,
    referralCode,
    parameterBag,
) => {
    const data = {
        discountCode,
        referralCode,
        parameterBag: JSON.stringify(parameterBag),
    };

    return await fetch(`${REGISTRATION}/${id}`, {
        method: 'PATCH',
        headers: {
            'content-type': 'application/json',
        },
        body: JSON.stringify(data),
    }).then(res => {
        if (!res.ok) {
            throw res.json();
        }

        return res.json();
    });
};

export const postActivateEmail: PostActivateEmailType = async data =>
    await fetch(REGISTRATION_PASSWORD_RESET, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
        },
        body: JSON.stringify(data),
    }).then(res => {
        if (!res.ok) {
            throw res.json();
        }

        return res.json();
    });

export const putConsentData: PutConsentDataType = async (
    selectedConsents,
    registrationId,
) => {
    const data = {
        consentVersions: selectedConsents,
    };

    return await fetch(`${REGISTRATION}/${registrationId}/consents`, {
        method: 'PUT',
        headers: {
            'content-type': 'application/json',
        },
        body: JSON.stringify(data),
    }).then(res => {
        if (!res.ok) {
            throw res.json();
        }

        return res.json();
    });
};
